import React from "react";
import { useJsApiLoader } from "@react-google-maps/api";

const libraries: ("places" | "drawing" | "geometry" | "visualization")[] = [
  "places",
];

interface GoogleMapLoaderProps {
  children: React.ReactNode;
}

const GoogleMapLoader: React.FC<GoogleMapLoaderProps> = ({ children }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAaYtKA9T1_a2nRuFbVcHbq03n-ndEWuBc",
    libraries,
  });

  if (!isLoaded) {
    return <div>جاري تحميل الخريطة...</div>;
  }

  return <>{children}</>;
};

export default GoogleMapLoader;
